import React, { useState, useEffect } from "react";

const MatchToggleButton = ({ data, refreshList }) => {
  const extractStatus = (status) => {
    if (status?.data) return status.data[0] === 1;
    return status === 1 || status === "1" || status === true;
  };

  const [isActive, setIsActive] = useState(extractStatus(data.status));

  useEffect(() => {
    setIsActive(extractStatus(data.status));
  }, [data.status]);

  const handleToggle = async (e) => {
    const checked = e.target.checked;
    setIsActive(checked); // Optimistic update

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_HOST}/match/status/${data.id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
          body: JSON.stringify({ status: checked ? 1 : 0 }),
        }
      );

      if (!res.ok) throw new Error("Update failed");
      await res.json();
      refreshList?.();
    } catch (err) {
      console.error("Toggle failed:", err);
      setIsActive(!checked); // Revert on error
    }
  };

  return (
    <div className="flex h-full w-full items-center justify-center">
      <label className="relative inline-block w-[50px] h-[24px] shrink-0 cursor-pointer">
        <input
          type="checkbox"
          checked={isActive}
          onChange={handleToggle}
          className="hidden"
        />
        <span
          className={`absolute inset-0 transition-colors duration-300 rounded-full ${
            isActive ? "bg-green-500" : "bg-gray-300"
          }`}
        ></span>
        <span
          className={`absolute left-[4px] bottom-[3px] w-[18px] h-[18px] bg-white rounded-full shadow transform transition-transform duration-300 ${
            isActive ? "translate-x-[26px]" : ""
          }`}
        ></span>
      </label>
    </div>
  );
};

export default MatchToggleButton;
